module.exports = __webpack_public_path__ + "img/Wei_Wang-1.350de412.png";